import React from 'react';
import { Typography, Grid, Divider } from '@material-ui/core';

import { Challenge, ChallengeStatus } from 'generated/graphql';
import BoxComponent from 'retired/Box';
import { format } from 'date-fns';

const getChallengeStatusColorAndLabel = (status: ChallengeStatus) => {
  switch (status) {
    case ChallengeStatus.Draft:
      return { color: '#FF866F', label: 'Draft' };
    case ChallengeStatus.Published:
      return { color: '#4DAD80', label: 'Published' };
    default:
      return { color: '#6369FF', label: 'Active' };
  }
};

const getStatusMessage = (challenge: Challenge) => {
  if (challenge.status === ChallengeStatus.Draft) {
    return 'Edit challenge to publish it.';
  }

  const now = new Date();
  const startDate = challenge.startDate ? new Date(challenge.startDate) : null;
  const endDate = challenge.endDate ? new Date(challenge.endDate) : null;

  if (endDate && now > endDate) {
    return 'Challenge has ended';
  } else if (startDate && now < startDate) {
    return `Challenge will start to be shown to users on ${format(
      new Date(challenge.startDate),
      'MM/dd/yyyy'
    )}`;
  } else {
    return 'Challenge is ongoing';
  }
};

export const ChallengePageDetails = ({ challenge }: { challenge: Challenge }) => {
  const { color, label } = getChallengeStatusColorAndLabel(challenge.status);

  return (
    <BoxComponent
      style={{
        borderTopWidth: 5,
        borderTopStyle: 'solid',
        borderTopColor: color,
      }}
    >
      <div
        style={{
          backgroundColor: '#f2f2f2',
          position: 'relative',
          justifyContent: 'center',
          display: 'flex',
          borderRadius: 10,
          minHeight: 120,
        }}
      >
        <div style={{ display: 'flex', alignSelf: 'flex-start' }}>
          <div
            style={{
              padding: 20,
              margin: 40,
              backgroundColor: 'rgba(255, 255, 255, .85)',
              borderRadius: 10,
              flexGrow: 2,
              zIndex: 1,
            }}
          >
            <Typography
              type="headline"
              component="h3"
              style={{
                fontSize: 17,
                marginBottom: 5,
              }}
              align="center"
            >
              <span
                style={{
                  color,
                  fontWeight: 800,
                  fontSize: 20,
                }}
              >
                Status: {label}
              </span>
            </Typography>
            <Typography component="p" style={{ fontSize: 15, fontWeight: 300 }} align="center">
              {getStatusMessage(challenge)}
            </Typography>
          </div>
        </div>
      </div>

      {challenge.startDate && challenge.endDate && (
        <>
          <Divider />
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'top',
              flexWrap: 'nowrap',
              paddingTop: 15,
              paddingBottom: 15,
            }}
          >
            <Grid container spacing={8}>
              <Grid item xs={5} lg={4} xl={3}>
                <Typography
                  type="headline"
                  component="h3"
                  style={{
                    fontSize: 15,
                    fontWeight: 500,
                    marginRight: 10,
                  }}
                >
                  Duration
                </Typography>
              </Grid>
              <Grid item xs={7} lg={8} xl={9}>
                {format(new Date(challenge.startDate), 'MM/dd/yyyy')} -{' '}
                {format(new Date(challenge.endDate), 'MM/dd/yyyy')}
              </Grid>
            </Grid>
          </div>
        </>
      )}

      <>
        <Divider />
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'nowrap',
            paddingTop: 15,
            paddingBottom: 15,
          }}
        >
          <Grid container spacing={8}>
            <Grid item xs={5} lg={4} xl={3}>
              <Typography
                type="headline"
                component="h3"
                style={{
                  fontSize: 15,
                  fontWeight: 500,
                  marginRight: 10,
                }}
              >
                Teams
              </Typography>
            </Grid>
            <Grid item xs={7} lg={8} xl={9}>
              <Typography component="p" style={{ fontSize: 15, fontWeight: 300 }}>
                {challenge.generalStats.totalTeams || 0}{' '}
                {challenge.generalStats.totalTeams !== 1 ? 'teams' : 'team'} participating
              </Typography>
            </Grid>
          </Grid>
        </div>
      </>
    </BoxComponent>
  );
};
